import { render, staticRenderFns } from "./AppNavbarVerticalLayout2.vue?vue&type=template&id=03ffeba5&"
import script from "./AppNavbarVerticalLayout2.vue?vue&type=script&lang=js&"
export * from "./AppNavbarVerticalLayout2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports